import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		userName: "",
		account:"",
		openid:"",
		isBind:false,
		dealId:""
	},
	mutations: {
		setUserName(state, newName) {
			state.userName = newName;
		},
		setAccount(state, newAccount){
			state.account = newAccount;
		},
		setOpenid(state, newOpenid){
			state.openid = newOpenid;
		},
		setIsBind(state, newIsBind){
			state.isBind = newIsBind;
		},
		setId(state, newId){
			state.id = newId;
		}
	},
	actions: {
		
	}
});

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js